
import React, {useContext} from 'react';
import FooterMenu from 'component/footer/footer_menu';
import Copyright from 'component/footer/copyright';
import './index.css';
import Img from 'img/footer/icons.png';
import Themes from 'themes';
const ThemeContext = React.createContext(Themes.themes1);

const Footer = () => {
  const Themes = useContext(ThemeContext);
  return(
    <div className="footerBox" style={{background: Themes.footerBox}}>
      <img src={Img} alt="" />
      <FooterMenu />
      <Copyright />
    </div>
  )
}

export default Footer
